import React, { memo } from 'react';
import PropTypes from 'prop-types';

import Logo from './Svgs/Logo';

const Navigation = ({ prevHash, steps, activeStep, onNavigation, onSave }) => (
  <div id="wrapper-navbar">
    <nav className="navbar navbar-expand-lg navbar-light bg-light navbar-quiz">
      <div className="row flex-1 align-items-center g-0">
        <div className="col-12 text-center pt-4 d-flex justify-content-center align-items-center">
          <a href="/" className="custom-logo-link">
            <Logo />
          </a>
          <button type="button" className="btn btn-text ms-auto p-0 d-lg-none" onClick={onSave}>
            {prevHash ? <span>Back to cart</span> : <span className="text-uppercase">Exit</span>}
          </button>
        </div>
        <div className="col-12">
          <ul className="steps-nav">
            {steps.map((step, i) => (
              <li key={step.name} className={`step ${activeStep === i ? 'active' : ''}${activeStep > i ? 'completed' : ''}`}>
                <button type="button" className="h5">
                  <span className="step-text">{step.name}</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  </div>
);

Navigation.propTypes = {
  prevHash: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      subSteps: PropTypes.number,
    }),
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
  onNavigation: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default memo(Navigation);
